/**
 * Unified feature navigation.
 * Single source of truth for WorkspaceShell, Layout, LayoutV2, FeatureHub, CrossAppLinks.
 */
export interface FeatureNavItem {
  label: string;
  path: string;
  emoji: string;
  tooltip: string;
  testId?: string;
  appKey?: 'screen' | 'litportal' | 'learn' | 'audio-digests' | 'litscholar' | 'community';
}

export const FEATURE_NAV: FeatureNavItem[] = [
  {
    label: 'LitScreen',
    path: '/screen',
    appKey: 'screen',
    emoji: '🔍',
    tooltip: 'Screen articles of interest from your queue',
    testId: 'nav-litscreen',
  },
  {
    label: 'LitHub',
    path: '/library/shelf',
    appKey: 'learn',
    emoji: '📚',
    tooltip: 'Your canonical article library',
    testId: 'nav-lithub',
  },
  {
    label: 'LitStream',
    path: '/audio-digests',
    appKey: 'audio-digests',
    emoji: '🎧',
    tooltip: 'Listen to your literature audio digests',
    testId: 'nav-litstream',
  },
  {
    label: 'LitScholar',
    path: '/litscholar',
    appKey: 'litscholar',
    emoji: '🧠',
    tooltip: 'Deep dive with AI',
    testId: 'nav-litscholar',
  },
  {
    label: 'LitClub',
    path: '/community',
    appKey: 'community',
    emoji: '💬',
    tooltip: 'Discuss with your peers',
    testId: 'nav-litclub',
  },
  {
    label: 'LitPortal',
    path: '/litportal',
    appKey: 'litportal',
    emoji: '🌐',
    tooltip: 'Clinical evidence search',
    testId: 'nav-litportal',
  },
];

/** Whether a feature nav item is active for the current pathname. */
export function isFeatureNavActive(pathname: string, itemPath: string): boolean {
  if (pathname === itemPath) return true;

  if (itemPath === '/library/shelf') {
    return (
      pathname === '/library/shelf' ||
      pathname.startsWith('/library/digests') ||
      pathname.startsWith('/library/articles') ||
      pathname.startsWith('/library/archive') ||
      pathname === '/learn' ||
      pathname.startsWith('/learn/')
    );
  }

  if (itemPath === '/litportal') {
    return pathname.startsWith('/litportal');
  }

  if (itemPath === '/screen') {
    return pathname.startsWith('/screen') || pathname.startsWith('/queue');
  }

  if (itemPath === '/community') {
    return pathname.startsWith('/community');
  }

  if (itemPath === '/audio-digests') {
    return pathname.startsWith('/audio-digests');
  }

  if (itemPath === '/litscholar') {
    return pathname.startsWith('/litscholar');
  }

  return false;
}

export const LITARCHIVE_PATH = '/library/archive';
export const LITHUB_SHELF_PATH = '/library/shelf';
